export default "__VITE_ASSET__C3or7B1X__"